import FooterDesk from "./Desk/FooterDesk";
import FooterMob from "./Mob/FooterMob";

const Footer = () => {
  return <>{window.innerWidth <= 767 ? <FooterMob /> : <FooterDesk />}</>;
};

export default Footer;
